<template>
  <div class="example">
    <b-card>
      <b-card-header>
        <b-card-title>Warehouse-wise Product Distribution</b-card-title>
      </b-card-header>
      <div v-if="validData.length > 0">
        <apexchart 
          type="bar"
          height="350"
          :options="chartOptions"
          :series="series"
        />
      </div>
      <div v-else class="text-center py-5">
        <i class="fas fa-chart-bar text-muted mb-3" style="font-size: 3rem;"></i>
        <h4 class="text-muted">No Warehouse Distribution Data Available</h4>
        <p>There is no warehouse distribution data for the selected date range. Try selecting a different period.</p>
      </div>
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";

export default {
  name: "BarChart",
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  components: {
    apexchart: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
  },
  computed: {
    validData() {
      if (!this.data || !Array.isArray(this.data)) {
        return [];
      }
      
      // Filter for warehouses with valid product data
      return this.data.filter(warehouse => 
        warehouse && 
        warehouse.name && 
        warehouse.products && 
        Array.isArray(warehouse.products) &&
        warehouse.products.length > 0
      );
    },
    
    // Get unique product names across all warehouses
    uniqueProducts() {
      const productSet = new Set();
      
      this.validData.forEach(warehouse => {
        warehouse.products.forEach(product => {
          if (product && product.name) {
            productSet.add(product.name);
          }
        });
      });
      
      return Array.from(productSet);
    },
    
    // Warehouse names for x-axis categories
    warehouseNames() {
      return this.validData.map(warehouse => warehouse.name);
    },
    
    // Create series data for each product
    series() {
      // For each unique product, create a data array with values for each warehouse
      return this.uniqueProducts.map((productName, index) => {
        const colors = ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#3F51B5', '#546E7A', '#D4526E'];
        
        return {
          name: productName,
          data: this.validData.map(warehouse => {
            // Find this product in the current warehouse
            const product = warehouse.products.find(p => p.name === productName);
            // Return the inventory value or 0 if not found
            return product ? Number(product.physicalInventory) : 0;
          }),
          color: colors[index % colors.length]
        };
      });
    },
    
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 350,
          stacked: false,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 20,
            columnWidth: '50%'
          }
        },
        xaxis: {
          categories: this.warehouseNames,
          title: {
            text: 'Warehouses'
          }
        },
        yaxis: {
          title: {
            text: 'Product Quantity'
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'top',
          horizontalAlign: 'center'
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + ' units';
            }
          }
        }
      };
    }
  }
};
</script>